/// <reference path="../../core/base-data.service.ts" />

namespace app {
	export class LanguageService extends DataService<Language> {
		public resource: string = "languages";
	}
	angular.module("app").service("LanguageService", LanguageService);
}